import { Component, inject, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Location } from "@angular/common";
import LogRocket from "logrocket";
import { ENVIRONMENT } from "@company-box/models";
import { AlertService } from "@company-box/services";
import { AlertComponent } from "ngx-bootstrap/alert";
import { RouterModule } from "@angular/router";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  imports: [RouterModule, AlertComponent],
})
export class AppComponent implements OnInit {
  environment = inject(ENVIRONMENT);
  location: Location = inject(Location);
  private titleService: Title = inject(Title);
  alertService = inject(AlertService);

  private title = this.environment.config.title;

  constructor() {}

  ngOnInit(): void {
    this.titleService.setTitle(this.title);

    if (this.environment.production) {
      if (location.protocol === "http:") {
        window.location.href = location.href.replace("http", "https");
      }
      LogRocket.init("edplti/companybox");
    }
  }
}
